import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { tr } from "../../lib/i18n";

export const TrustBadge = ({ className = "", testid = "trust-badge" }) => (
  <Link to="/trust#at-a-glance" data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full border border-emerald-600/30 bg-emerald-50 dark:bg-emerald-950/30 px-3 py-1 text-xs text-emerald-800 dark:text-emerald-300 hover:border-emerald-600 transition-colors ${className}`}>
    <ShieldCheck className="h-3.5 w-3.5" /> {tr("Security at a glance — every file encrypted, no ads or trackers")}
  </Link>
);
